module.exports = (window.__MEEGO_GLOBAL__?.loadRemoteEntryContainer?.('@meego-remote/core') || new Promise(resolve => {
      const proxy = {
        get: async (request) => {
            const mod = await window['meego_remote'].get(request);
            const res = await mod();
            return () => res;
        },
        init: (arg) => {
          try {
            window['meego_remote'].init(arg);
          } catch(e) {
            console.log('remote container already initialized')
          }
        }
      };
      if (window['meego_remote']) {
        resolve(proxy);
        return;
      }
      const createScript = function(remoteUrl) {
        const script = document.createElement('script')
        script.src = remoteUrl;
        script.onload = () => {
          resolve(proxy)
        }
        document.head.appendChild(script);
      };
      if (window.__MEEGO_HOST_MANIFESTS_SSG__) {
        createScript(/^https/.test(window.__MEEGO_HOST_MANIFESTS_SSG__) ? window.__MEEGO_HOST_MANIFESTS_SSG__ : ('https:' + window.__MEEGO_HOST_MANIFESTS_SSG__));
      } else if ('') {
        fetch('').then(res => res.json()).then(res => {
          if (res?.remoteEntry?.url) {
            createScript('https:' + res.remoteEntry.url);
          } else {
            throw new Error('拉取内容异常')
          }
        });
      } else {
        fetch('/b/meego_project_fe/host/manifest').then(res => res.text()).then(res => {
          createScript('https:' + res);
        });
      }
    }))
    ;